export const GET_CTAS_LIST = 'GET_CTAS_LIST';
export const GET_CTAS_LIST_SUCCESS = 'GET_CTAS_LIST_SUCCESS';
export const GET_CTAS_LIST_FAIL = 'GET_CTAS_LIST_FAIL';
export const CREATE_CTA = 'CREATE_CTA';
export const UPDATE_CTA = 'UPDATE_CTA';
export const DELETE_CTA = 'DELETE_CTA';
export const DELETE_CTA_SUCCESS = 'DELETE_CTA_SUCCESS';
export const DELETE_CTA_FAIL = 'DELETE_CTA_FAIL';

export const getCtasList = (userId, userType) => ({
  type: GET_CTAS_LIST,
  userId,
  userType
});

export const getCtasListSuccess = (ctas) => ({
  type: GET_CTAS_LIST_SUCCESS,
  ctas
});

export const getCtasListFail = () => ({
  type: GET_CTAS_LIST_FAIL
});

export const deleteCtaSuccess = (id) => ({
  type: DELETE_CTA_SUCCESS,
  id
});

export const deleteCtaFail = (id) => ({
  type: DELETE_CTA_FAIL,
  id
});

export const createCta = (ctaData) => ({
  type: CREATE_CTA,
  ctaData
});

export const updateCta = (id, ctaData) => ({
  type: UPDATE_CTA,
  id,
  ctaData
});

export const deleteCta = (id) => ({
  type: DELETE_CTA,
  id
});
